export default __webpack_public_path__ + "static/media/elevatorInspect.3cff248e.png";